import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';
import { getFormattedPhoneNumber } from './format-phone.helper';

@Pipe({
  name: 'formatPhoneNumber',
  standalone: true,
})
export class FormatPhoneNumberPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(phoneNumber: string): string {
    if (!phoneNumber || phoneNumber === NO_VALUE) {
      return NO_VALUE;
    }

    return getFormattedPhoneNumber(phoneNumber, this.locale);
  }
}
